import styled from 'styled-components';

export const HealthUnitsInfoContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(4, 169px);
  gap: 12px;

  @media (max-width: 768px) {
    grid-template-columns: repeat(2, 1fr);
    padding: 0 4px;
  }

  @media (min-width: 1024px) and (max-width: 1440px) {
    grid-template-columns: repeat(4, 140px);
  }
`;
